import { API_V2 } from './apiVersion';

export const POSTER_ENDPOINTS = {
  SUPERADMIN: {
    LIST: `${API_V2}/superadmin/posters`,
    CREATE: `${API_V2}/superadmin/posters`,
    PRESIGN: `${API_V2}/superadmin/posters/presign`,

    DELETE: (posterId: number) =>
      `${API_V2}/superadmin/posters/${posterId}`,
  },
} as const;
